export default __webpack_public_path__ + "static/banner-mobile-25838455b8829bfb2cb2a240d7633456.svg";